import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BoldedSmallerFontSpan = styled.span.withConfig({
  displayName: "LabelAndButton__BoldedSmallerFontSpan",
  componentId: "gnrxln-0"
})(["font-size:12px;font-weight:500;margin-right:8px;"]);
const LabelAndButton = ({
  Button = null,
  label,
  wrapperClassName
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperClassName,
    children: [/*#__PURE__*/_jsx(BoldedSmallerFontSpan, {
      children: label
    }), Button]
  });
};
export default LabelAndButton;